module.exports = __webpack_public_path__ + "img/pdf.227050b5.svg";